'use client';

import { type ComponentProps, type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Skeleton } from '@videoblocks/design-system';

export type PlaybackCardProps = ComponentProps<'video'>;

export function PlaybackCard({
    autoPlay = true,
    muted = true,
    loop = true,
    controls = true,
    className,
    src,
    ...rest
}: PlaybackCardProps): JSX.Element {
    return (
        <div
            className={twMerge(
                'relative size-full aspect-video flex rounded-sm justify-center items-center overflow-hidden',
                className,
            )}
        >
            {src ? (
                <video
                    className="size-full"
                    src={src}
                    {...rest}
                    autoPlay={autoPlay}
                    preload="metadata"
                    muted={muted}
                    loop={loop}
                    controls={controls}
                    playsInline
                />
            ) : (
                <Skeleton className="size-full" data-testid="playback-card-skeleton" />
            )}
            <div
                className="pointer-events-none absolute inset-0 rounded-[inherit] inset-ring-1 inset-ring-white/20"
                data-testid="playback-card-ring"
            />
        </div>
    );
}
